<div class="modal-overlay" *ngIf="isOpen">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Add Customer</h2>
        <button class="close-button" (click)="onClose()" type="button" [disabled]="isSubmitting">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Form Content -->
    <div class="modal-body">
      <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
        <!-- First Row: First Name & Last Name -->
        <div class="form-row">
          <div class="form-field phone-input-wrapper">
            <label class="field-label">First Name</label>
            <div class="input-container phone-input-container">
              <input
                type="text"
                class="form-input"
                [class.error]="
                  getFieldError('firstName') || customerForm.get('firstName')?.value?.length >= 50
                "
                formControlName="firstName"
                placeholder="e.g. John"
                [disabled]="isSubmitting"
                (input)="onFirstNameInput($event)"
                (blur)="hideNameDropdown()"
              />
              <!-- Name Search Dropdown -->
              <!-- <div class="phone-search-dropdown" 
                   *ngIf="showNameDropdown && nameSearchResults.length > 0"
                   (mousedown)="$event.preventDefault()">
                <div class="dropdown-item" 
                     *ngFor="let customer of nameSearchResults; trackBy: trackByIndex" 
                     (click)="selectCustomerFromSearch(customer)">
                  <div class="customer-info">
                    <div class="customer-name">{{ customer.first_name }} {{ customer.last_name || '' }}</div>
                    <div class="customer-details">
                      <span class="customer-phone">{{ customer.contact }}</span>
                      <span class="customer-email" *ngIf="customer.email">{{ customer.email }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="phone-search-loading" *ngIf="isSearchingCustomersByName">
                <div class="loading-spinner"></div>
                <span>Searching...</span>
              </div> -->
            </div>
            <div class="error-message" *ngIf="getFieldError('firstName')">
              {{ getFieldError('firstName') }}
            </div>
            <div
              class="error-message"
              *ngIf="customerForm.get('firstName')?.errors?.['standardName']"
            >
              {{ customerForm.get('firstName')?.errors?.['standardName']?.message }}
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">Last Name</label>
            <div class="input-container">
              <input
                type="text"
                class="form-input"
                [class.error]="
                  getFieldError('lastName') || customerForm.get('lastName')?.value?.length >= 50
                "
                formControlName="lastName"
                placeholder="e.g. Smith"
                [disabled]="isSubmitting"
              />
            </div>
            <div class="error-message" *ngIf="getFieldError('lastName')">
              {{ getFieldError('lastName') }}
            </div>
            <div
              class="error-message"
              *ngIf="customerForm.get('lastName')?.errors?.['standardName']"
            >
              {{ customerForm.get('lastName')?.errors?.['standardName']?.message }}
            </div>
          </div>
        </div>

        <!-- Second Row: Phone & Email -->
        <div class="form-row">
          <div class="form-field phone-input-wrapper">
            <label class="field-label">Phone</label>
            <div class="input-container phone-input-container">
              <input
                type="tel"
                inputmode="tel"
                autocomplete="tel"
                class="form-input"
                [class.error]="getFieldError('phone') || duplicatePhoneError"
                formControlName="phone"
                placeholder="e.g. (930) 947 2749"
                [attr.maxlength]="phoneMaxLength"
                [disabled]="isSubmitting"
                (input)="onPhoneInput($event)"
                (keyup)="onPhoneKeyup()"
                (blur)="hidePhoneDropdown()"
              />
              <!-- Phone Search Dropdown -->
              <!-- <div class="phone-search-dropdown" 
                   *ngIf="showPhoneDropdown && phoneSearchResults.length > 0"
                   (mousedown)="$event.preventDefault()">
                <div class="dropdown-item" 
                     *ngFor="let customer of phoneSearchResults; trackBy: trackByIndex" 
                     (click)="selectCustomerFromSearch(customer)">
                  <div class="customer-info">
                    <div class="customer-name">{{ customer.first_name }} {{ customer.last_name || '' }}</div>
                    <div class="customer-details">
                      <span class="customer-phone">{{ customer.contact }}</span>
                      <span class="customer-email" *ngIf="customer.email">{{ customer.email }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="phone-search-loading" *ngIf="isSearchingCustomers">
                <div class="loading-spinner"></div>
                <span>Searching...</span>
              </div> -->
            </div>
            <div class="error-message" *ngIf="getFieldError('phone')">Invalid phone number.</div>
            <div class="error-message" *ngIf="duplicatePhoneError">
              {{ duplicatePhoneError }}
              <ng-container
                *ngTemplateOutlet="
                  viewExistingCustomerLink;
                  context: { errorText: duplicatePhoneError }
                "
              ></ng-container>
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">Email</label>
            <div class="input-container">
              <input
                type="email"
                class="form-input"
                [class.error]="getFieldError('email') || duplicateEmailError"
                formControlName="email"
                placeholder="e.g. johnsmith@example.com"
                [disabled]="isSubmitting"
                (input)="onEmailInput()"
              />
            </div>
            <div class="error-message" *ngIf="getFieldError('email')">
              {{ getFieldError('email') }}
            </div>
            <div class="error-message" *ngIf="customerForm.get('email')?.errors?.['strictEmail']">
              invalid email address.
            </div>
            <div class="error-message" *ngIf="duplicateEmailError">
              {{ duplicateEmailError }}
              <ng-container
                *ngTemplateOutlet="
                  viewExistingCustomerLink;
                  context: { errorText: duplicateEmailError }
                "
              ></ng-container>
            </div>
          </div>
        </div>

        <!-- Third Row: License Plate -->
        <div class="form-row">
          <div class="form-field">
            <label class="field-label"
              >License Plate with State Code<span class="required">*</span></label
            >
            <div class="input-container">
              <input
                type="text"
                class="form-input"
                [class.error]="getFieldError('licensePlate') || duplicateLicensePlateError"
                formControlName="licensePlate"
                placeholder="e.g. CA37216"
                [disabled]="isSubmitting"
                (input)="onLicensePlateInput()"
                maxlength="10"
              />
            </div>
            <div class="error-message" *ngIf="getFieldError('licensePlate')">
              {{ getFieldError('licensePlate') }}
            </div>
            <div class="error-message" *ngIf="duplicateLicensePlateError">
              {{ duplicateLicensePlateError }}
              <ng-container
                *ngTemplateOutlet="
                  viewExistingCustomerLink;
                  context: { errorText: duplicateLicensePlateError }
                "
              ></ng-container>
            </div>
            <!-- <div class="error-message" *ngIf="customerForm.get('licensePlate')?.errors?.['usaLicensePlate']">
              Invalid license plate.
            </div> -->
          </div>
        </div>

        <!-- Vehicle Fields Row: Make, Model, Year (shown when "Invalid license plate" error occurs) -->
        <div class="form-row" *ngIf="showVehicleFields">
          <div class="form-field">
            <label class="field-label">Make</label>
            <div class="input-container">
              <input
                type="text"
                class="form-input"
                [class.error]="getFieldError('make')"
                formControlName="make"
                placeholder="e.g. Toyota"
                [disabled]="isSubmitting"
                (input)="onMakeInput()"
                maxlength="50"
              />
            </div>
            <div class="error-message" *ngIf="getFieldError('make')">
              {{ getFieldError('make') }}
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">Model<span class="required">*</span></label>
            <div class="input-container">
              <input
                type="text"
                class="form-input"
                [class.error]="getFieldError('model')"
                formControlName="model"
                placeholder="e.g. Camry"
                [disabled]="isSubmitting"
                (input)="onModelInput()"
                maxlength="50"
              />
            </div>
            <div class="error-message" *ngIf="getFieldError('model')">
              {{ getFieldError('model') }}
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">Year</label>
            <div class="input-container">
              <input
                type="text"
                class="form-input"
                [class.error]="getFieldError('year')"
                formControlName="year"
                placeholder="e.g. 2020"
                [disabled]="isSubmitting"
                maxlength="4"
                (input)="onYearInput()"
              />
            </div>
            <div class="error-message" *ngIf="getFieldError('year')">
              {{ getFieldError('year') }}
            </div>
            <!-- <div class="error-message" *ngIf="customerForm.get('year')?.errors?.['vehicleYear']">
              {{ customerForm.get('year')?.errors?.['vehicleYear']?.message }}
            </div> -->
          </div>
        </div>

        <!-- Fourth Row: Location -->
        <!-- <div class="form-row">
          <div class="form-field country-select">
            <label class="field-label">Location<span class="required">*</span></label>
            <div class="input-container">
              <mat-select 
                formControlName="locationId"
                placeholder="Select a location"
                [disabled]="isSubmitting || isLoadingLocations"
                [class.error]="getFieldError('locationId')">
                <mat-option *ngIf="isLoadingLocations" [disabled]="true" class="loading-locations">
                  Loading locations...
                </mat-option>
                <mat-option *ngFor="let location of locationOptions" [value]="location.value">
                  {{ location.label }}
                </mat-option>
              </mat-select>
            </div>
            <div class="error-message" *ngIf="getFieldError('locationId')">
              {{ getFieldError('locationId') }}
            </div>
          </div>
        </div> -->
      </form>
    </div>

    <!-- Footer -->
    <app-modal-footer-actions
      footerClass="modal-footer"
      secondaryText="Clear"
      primaryText="Create Customer"
      primaryLoadingText="Creating..."
      [secondaryDisabled]="isSubmitting"
      [cancelDisabled]="isSubmitting"
      [primaryDisabled]="isSubmitting || !isLicensePlateValid"
      [primaryLoading]="isSubmitting"
      [primaryExtraClass]="{ disabled: isSubmitting || !isLicensePlateValid }"
      (secondaryClick)="onClear()"
      (cancelClick)="onClose()"
      (primaryClick)="onSubmit()"
    />
  </div>
</div>

<!-- Customer Details Modal -->
<app-customer-details-modal
  *ngIf="showCustomerDetails && existingCustomerData"
  [customer]="existingCustomerData"
  [isVisible]="showCustomerDetails"
  (close)="onCloseCustomerDetails()"
>
</app-customer-details-modal>

<!-- View Existing Customer Link Template (reused for duplicate phone and email error messages) -->
<ng-template #viewExistingCustomerLink let-errorText="errorText">
  <span
    class="view-link"
    *ngIf="existingCustomerData && errorText.toLowerCase().includes('already exists')"
    (click)="onViewExistingCustomer()"
    [class.loading]="isLoadingCustomerDetails"
    [style.pointer-events]="isLoadingCustomerDetails ? 'none' : 'auto'"
  >
    <span *ngIf="!isLoadingCustomerDetails">View</span>
    <span *ngIf="isLoadingCustomerDetails">Loading...</span>
    <svg
      *ngIf="!isLoadingCustomerDetails"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99935 1.99984H1.99935C1.64573 1.99984 1.30659 2.14031 1.05654 2.39036C0.806491 2.64041 0.666016 2.97955 0.666016 3.33317V9.99984C0.666016 10.3535 0.806491 10.6926 1.05654 10.9426C1.30659 11.1927 1.64573 11.3332 1.99935 11.3332H8.66601C9.01964 11.3332 9.35877 11.1927 9.60882 10.9426C9.85887 10.6926 9.99935 10.3535 9.99935 9.99984V5.99984M5.33268 6.6665L11.3327 0.666504M11.3327 0.666504H7.99935M11.3327 0.666504V3.99984"
        stroke="#0040E0"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</ng-template>
